
export function processMaintenanceText(message: any): { es: { title: string; text: string }[]; en: { title: string; text: string }[] } {
  try {
    let parsed = JSON.parse(message);

    const partesEs = parsed.es.split('\n\n');
    const titleEs = partesEs[0]?.trim().replace('#', '').trim() || '';
    const textEs = partesEs.slice(1).join('\n\n').trim() || '';

    const partesEn = parsed.en.split('\n\n');
    const titleEn = partesEn[0]?.trim().replace('#', '').trim() || '';
    const textEn = partesEn.slice(1).join('\n\n').trim() || '';

    return {
      es: [
        {
          title: titleEs,
          text: textEs,
        },
      ],
      en: [
        {
          title: titleEn,
          text: textEn,
        },
      ],
    };

  } catch (error) {
    console.error('Error al parsear el string JSON:', error);
    return {
      es: [
        {
          title: '',
          text: '',
        },
      ],
      en: [
        {
          title: '',
          text: '',
        },
      ],
    };
  }
}